import { Component, OnInit } from '@angular/core';
import { ActivatedRoute}  from '@angular/router';

import { Subject } from 'rxjs';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

///IDIOMAS
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-norm35-document-table',
  templateUrl: './norm35-document-table.component.html',
  styleUrls: ['./norm35-document-table.component.scss']
})
export class Norm35DocumentTableComponent implements OnInit {
  private _unsubscribeAll: Subject<any>;

  info = [
    {
      position: '111',
      title: 'WIZARD.Guia2.title',
      subtitle: 'WIZARD.Guia2.subtitle',
      content: 'WIZARD.Guia2.content',
      content2: 'WIZARD.Guia2.content2'
    },{
      position: '112',
      title: 'WIZARD.Guia3.title',
      subtitle: 'WIZARD.Guia3.subtitle',
      content: 'WIZARD.Guia3.content',
      content2: 'WIZARD.Guia3.content2',
    },
  ]
// CG Norma 35-12


  preguntasSeccion1 = [
    {
      def: "WIZARD.Guia2.indica1",
      seccion : [
        {
          id: 1,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre1"
        },{
          id: 2,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre2"
        },{
          id: 3,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre3"
        },{
          id:4,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre4"
        },{
          id:5,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre5"
        },{
          id:6,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre6"
        },{
          id:7,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre7"
        },{
          id:8,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre8"
        },{
          id:9,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre9"
        }
      ]
    },{
      def: "WIZARD.Guia2.indica2",
      seccion : [
        { id:10,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre10"
        },{
          id:11,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre11"
        },{
          id:12,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre12"
        },{
          id:13,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre13"
        }
      ]
    },{
      def: "WIZARD.Guia2.indica3",
      seccion : [
        {
          id:14,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre14"
        },{
          id:15,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre15"
        },{
          id:16	,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre16"
        },{
          id:17,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre17"
        }
      ]
    },{
      def : "WIZARD.Guia2.indica4",
      seccion : [
        {
          id:18,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre18"
        },{
          id:19,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre19"
        },{
          id:20,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre20"
        },{
          id:21,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre21"
        },{
          id:22,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre22"
        }
      ]
    },{
      def: "WIZARD.Guia2.indica5",
      seccion : [
        {
          id:23,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre23"
        },{
          id:24,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre24"
        },{
          id:25,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre25"
        },{
          id:26,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre26"
        },{
          id:27,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre27"
        }
      ]
    },{
      def: "WIZARD.Guia2.indica6",
      seccion : [
        {
          id:28,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre28"
        },{
          id:29,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre29"
        },{
          id:30,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre30"
        },{
          id:31,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre31"
        },{
          id:32,
          pregunta:"WIZARD.Guia2.tablas.preguntas.pre32"
        },{
          id:33,
          pregunta:"WIZARD.Guia2.tablas.preguntas.pre33"
        },{
          id:34,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre34"
        },{
          id:35,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre35"
        },{
          id:36,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre36"
        },{
          id:37,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre37"
        },{
          id:38,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre38"
        },{
          id:39,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre39"
        },{
          id:40,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre40"
        }
      ]
    },{
      def: "WIZARD.Guia2.indica7",
      seccion : [
        {
          id:41,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre41"
        },{
          id:42,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre42"
        },{
          id:43,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre43"
          }
      ]
    },{
      // def: "Soy jefe de otros trabajadores:	",
      def: "WIZARD.Guia2.labelp",
      seccion : [
        {
          id:44,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre44"
        },{
          id:45,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre45"
        },{
          id:46,
          pregunta: "WIZARD.Guia2.tablas.preguntas.pre46"
        }

      ]
    }
  ]

  preguntasSeccion2 = [
    {
      def : "WIZARD.Guia3.PREGUNTAS.SECCION1.DESCRIPTION",
      seccion : [
        {
          id:1,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION1.QUES1"
        },{
          id:2,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION1.QUES2"
        },{
          id:3,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION1.QUES3"
        },{
          id:4,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION1.QUES4"
        },{
          id:5,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION1.QUES5"
        }
      ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION2.DESCRIPTION",
    seccion: [
        {
          id:6,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION2.QUES1"
        },{
          id:7,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION2.QUES2"
        },{
          id:8,
          pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION2.QUES3"
        }
      ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION3.DESCRIPTION",
    seccion: [
      {
        id:9,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION3.QUES1"
      },{
        id:10,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION3.QUES2"
      },{
        id:11,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION3.QUES3"
      },{
        id:12,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION3.QUES4"
      }
    ]
  },{
    def:"WIZARD.Guia3.PREGUNTAS.SECCION4.DESCRIPTION",
    seccion:[
      {
        id:13	,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION4.QUES1"
      },{
        id:14,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION4.QUES2"
      },{
        id:15,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION4.QUES3"
      },{
        id:16,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION4.QUES4"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION5.DESCRIPTION",
    seccion:[
      {
        id:17,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES1"
      },{
        id:18,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES2"
      },{
        id:19,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES3"
      },{
        id:20,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES4"
      },{
        id:21,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES5"
      },{
        id:22,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION5.QUES6"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION6.DESCRIPTION",
    seccion: [
      {
        id:23,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES1"
      },{
        id:24,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES2"
      },{
        id:25,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES3"
      },{
        id:26,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES4"
      },{
        id:27,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES5"
      },{
        id:28,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION6.QUES6"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION7.DESCRIPTION",
    seccion:[
      {
        id:29,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION7.QUES1"
      },{
        id:30,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION7.QUES2"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION8.DESCRIPTION",
    seccion:[
      {
        id:31,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES1"
      },{
        id:32,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES2"
      },{
        id:33,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES3"
      },{
        id:34,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES4"
      },{
        id:35,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES5"
      },{
        id:36,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION8.QUES6"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION9.DESCRIPTION",
    seccion:[
      {
        id:37,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION9.QUES1"
      },{
        id:38,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION9.QUES2"
      },{
        id:39,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION9.QUES3"
      },{
        id:40,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION9.QUES4"
      },{
        id:41,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION9.QUES5"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION10.DESCRIPTION",
    seccion: [
      {
        id:42,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION10.QUES1"
      },{
        id:43,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION10.QUES2"
      },{
        id:44,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION10.QUES3"
      },{
        id:45,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION10.QUES4"
      },{
        id:46,
        pregunta: "WIZARD.Guia3.PREGUNTAS.SECCION10.QUES5"
      }
    ]
  },{
    def : "WIZARD.Guia3.PREGUNTAS.SECCION11.DESCRIPTION",
    seccion: [
      {
        id:47,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES1"
      },{
        id:48,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES2"
      },{
        id:49,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES3"
      },{
        id:50,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES4"
      },{
        id:51,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES5"
      },{
        id:52,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES6"
      },{
        id:53,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES7"
      },{
        id:54,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES8"
      },{
        id:55,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES9"
      },{
        id:56,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION11.QUES10"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION12.DESCRIPTION",
    seccion: [
      {
        id:57,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES1"
      },{
        id:58,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES2"
      },{
        id:59,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES3"
      },{
        id:60,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES4"
      },{
        id:61,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES5"
      },{
        id:62,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES6"
      },{
        id:63,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES7"
      },{
        id:64,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION12.QUES8"
      }
    ]
  },{
    def: "WIZARD.Guia3.PREGUNTAS.SECCION13.DESCRIPTION",
    seccion: [
      {
        id:65,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION13.QUES1"
      },{
        id:66,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION13.QUES2"
      },{
        id:67,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION13.QUES3"
      },{
        id:68,
        pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION13.QUES4"
      },
    ]
  },{
    def:"WIZARD.Guia3.PREGUNTAS.SECCION14.DESCRIPTION",
    seccion:[
      {
        id:69,	pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION14.QUES1"
      },
    {id:70,	pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION14.QUES2"},
    {id:71,	pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION14.QUES3"},
    {id:72,	pregunta:"WIZARD.Guia3.PREGUNTAS.SECCION14.QUES4"}
    ]
  }

  ]


  dataId : any ;
  idiomaBanner :any;
  constructor(private activated: ActivatedRoute,private translateSrv: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService) {
      this._unsubscribeAll = new Subject();
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });


    }
  ngOnInit() {
    this.activated.data.subscribe  (params=>{this.dataId = params});
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }

  cambiaIdiomaBanner(idioma:string){
    console.log("idioma "+idioma);
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma;
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }

  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-12.png';
  }

}
